'use client';

import { createContext, useContext, ReactNode } from 'react';
import { ProjectId } from '@projectsConfig';

interface ProjectContextType {
  projectId: ProjectId;
}

const ProjectContext = createContext<ProjectContextType | undefined>(undefined);

export function useProject() {
  const context = useContext(ProjectContext);
  if (!context) {
    throw new Error('useProject must be used within ProjectProvider');
  }
  return context;
}

interface ProjectProviderProps {
  children: ReactNode;
  projectId: ProjectId;
}

export function ProjectProvider({ children, projectId }: ProjectProviderProps) {
  return (
    <ProjectContext.Provider value={{ projectId }}>
      {children}
    </ProjectContext.Provider>
  );
}
